module.exports = __webpack_public_path__ + "4b533051f077d196493ce0213664e077.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/trevo.svg
// module id = 362
// module chunks = 0